import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CartIcon from '../../icons/cart';
import './style.css';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Garden of Ashes by Cookie Mueller | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Garden of Ashes, Cookie Mueller's second entry into the Hanuman Books canon brings together ten stories.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/Garden_Back.png', '../../Series-One/Garden_Side.png', '../../Series-One/Garden_Front.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Garden of Ashes</h1>
            <div className='productAuthor'>Cookie Mueller</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378036'} />
            <div className='productPrice'>$15.99 USD</div>
          </div>

          <div className='productDescription'>Cookie Mueller’s <em>Garden of Ashes</em> brings together ten stories, autobiographical accounts of her ascent to cult-cinema superstardom, with tales dedicated to several of her fellow Dreamlanders.

          </div>
          <div className='productDescription'>
            <p>Writer, actress, underground It Girl and overall cult figure <strong>Cookie Mueller</strong> (1949–1989) is among the most beloved authors originally published by Hanuman Books. Radical in spirit and exactingly composed, Mueller’s work has had a significant cultural comeback in recent years through new collections and literary portraits. Mueller was famously immortalized on screen as a member of the film director John Waters' Dreamlanders, whose poignant oral histories suffuse her texts with sensitivity and gravitas.</p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Spring 2026</div>
            <div>ISBN 9798989378036</div>
            <div>4.125 x 2.75 inches</div>
            <div>156 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}